import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDebounce } from "react-use";
import CustomAutocomplete from "../CustomAutocomplete";

export const OBJECTS_QUERY = gql`
  query listDevices($filter: ObjectFilter, $first: Int) {
    objects(orderBy: NAME_ASC, filter: $filter, first: $first) {
      id
      name
    }
  }
`;

const objectsAutocomplete = (props) => {
  const [objects, setObjects] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const [objectsLoad, objectsResult] = useLazyQuery(OBJECTS_QUERY, {
    onCompleted: (e) => {
      setObjects(
        e.objects.map((item) => ({ value: item.id, title: item.name }))
      );
    },
    fetchPolicy: "network-only",
    variables: {
      first: 20,
      filter: {
        schemaId: {
          equalTo: props.schemaId,
        },
        enabled: {
          equalTo: true,
        },
        name: {
          includesInsensitive: debouncedValue,
        },
      },
    },
  });

  const [, cancel] = useDebounce(
    () => {
      setDebouncedValue(inputValue);
    },
    500,
    [inputValue]
  );

  useEffect(() => {
    if (props.schemaId) {
      setValue("");
      objectsLoad();
    } else {
      setObjects([]);
      setValue("");
    }
  }, [props.schemaId]);

  useEffect(() => {
    if (props.schemaId) {
      objectsLoad();
    }
  }, [debouncedValue]);

  useEffect(() => {
    if (props.objectId) {
      const targetValue = objects.find((item) => item.value === props.objectId);

      if (targetValue) {
        handleChange({
          target: {
            name: props.name,
            rawValue: targetValue,
            value: targetValue?.value,
          },
        });
      }
    }
  }, [objects]);

  const handleInputChange = (e) => {
    if (e && e.currentTarget.value !== 0) {
      setInputValue(e.currentTarget.value.trim());
    }
  };
  const handleChange = (e) => {
    setValue(e.target.value);
    props.handleChange(e);
  };

  return (
    <>
      <CustomAutocomplete
        clearFieldIcon={true}
        error={props.error}
        helperText={props.helperText}
        autoComplete
        filterOptions={(x) => x}
        name={props.name}
        disabled={!props.schemaId}
        label={"Object name"}
        list={objects}
        value={value}
        loading={objectsResult.loading}
        onChange={handleChange}
        onInputChange={handleInputChange}
      />
    </>
  );
};

export default objectsAutocomplete;
